import React from 'react'
import SearchIcon from "@material-ui/icons/Search";
import {
    makeStyles,
    Typography,
    CircularProgress

} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete'
import { FetchJobSeekerCoach } from "../apis";
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
    },
    table: {
        minWidth: 1050,
    },
    tableHeadCell: {
        fontSize: "18px",
    },
    tableRowCell: {
        fontSize: "14px",
        borderBottom: "none",
        lineHeight: "40px",
        align: "left",
    },
    dropdown: {
        position: "absolute",
        top: 28,
        right: 0,
        left: 0,
        zIndex: 1,
        border: "1px solid",
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#f2f2f2",
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto",
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
        fontSize: "14px",
    },
    inputInput: {
        padding: theme.spacing(1.5, 1.5, 1.5, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "40ch",
        },
    },
}));

 function SeeCoach({ selectedUser }) {

    // const classes = useStyles();

    const [coach, setCoach] = React.useState()
    const [loading, setLoading] = React.useState(false)


    const fetchCoach = async () => {
        setLoading(true)
        let data = await FetchJobSeekerCoach(selectedUser)
        setCoach(data.user)
        setLoading(false)
    }

    React.useEffect(() => {
        fetchCoach()
    }, [])


    return (
        loading ? <CircularProgress size="17px" className="mx-7 " /> : <Typography > {coach && coach._id ? `${coach.firstName} ${coach.lastName}` : 'N/A'}</Typography>
    )
}

export default React.memo(SeeCoach)